var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTextoNegro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 445.943,
    height: 259.324,
    viewBox: "0 0 445.943 259.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGOTIPO_PRINCIPAL_POSITIVO_B-N_RGB",
    transform: "translate(-207 -173.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(437.079 173.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M427.76,252.959V173.23H453.1v78.187c0,7.879,1.7,10.2,6.18,10.2,4.794,0,6.024-2.168,6.024-10.2V173.23h25.347v79.729c0,23.335-11.746,33.226-31.371,33.226C438.735,286.185,427.76,276.295,427.76,252.959Z",
    transform: "translate(-427.76 -173.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M525.138,284.486H500.26V173.23h31.371c22.564,0,31.527,8.963,31.527,27.817v19.625c0,18.7-8.963,29.672-31.527,29.672h-6.493Zm0-56.248h5.1c4.94,0,7.421-2.783,7.421-8.192V202.12c0-5.253-2.314-7.723-7.264-7.723h-5.253v33.841Z",
    transform: "translate(-424.699 -173.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M571.13,284.486V173.23h22.71l19.625,54.393,1.7,6.18-.459-10.047V173.23h22.866V284.486H615.32l-20.083-54.393-1.855-6.337L594,234.731v49.755H571.13Z",
    transform: "translate(-421.708 -173.23)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(207 173.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M300.987,173.23V432.147H263.144v-189.7l-1.073.99A309.255,309.255,0,0,1,207,284.737V241.922a269.98,269.98,0,0,0,29.578-23.95,273.694,273.694,0,0,0,38.614-44.742h25.795Z",
    transform: "translate(-207 -173.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M404.637,241.922v42.814a310.134,310.134,0,0,1-55.071-41.3l-1.073-.99v189.7H310.65V173.23h25.795a274.2,274.2,0,0,0,38.614,44.742A268.023,268.023,0,0,0,404.637,241.922Z",
    transform: "translate(-202.624 -173.23)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(441.55 314.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M432.05,330.076V308.94h5.4v20.8c0,2.887.74,3.992,2.678,3.992s2.678-1.073,2.678-3.992v-20.8h5.357v21.136c0,6.18-2.845,8.859-8.035,8.859C434.77,338.935,432.05,336.256,432.05,330.076Z",
    transform: "translate(-432.05 -308.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M451.38,338.486V308.95h4.742l6.8,16.644,1.032,3.335-.292-3.992V308.95h4.815v29.536h-4.617l-6.962-16.769-1.032-3.544.334,4.409v15.9H451.38Z",
    transform: "translate(-431.234 -308.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M471.11,333.453h3.46V313.88h-3.46v-4.94H483.1v4.94h-3.377v19.573H483.1v5.023H471.11Z",
    transform: "translate(-430.401 -308.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M484.75,308.94h5.44l3.5,17.634.292,4.325.292-4.325,3.418-17.634h5.4l-6.43,29.536h-5.357Z",
    transform: "translate(-429.825 -308.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M504.95,338.486V308.95h13.8v4.815h-8.536V321.1h7.494v4.867h-7.494V333.5h8.775v4.982H504.95Z",
    transform: "translate(-428.973 -308.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M526.779,338.486H521.63V308.95h7.952c5.565,0,7.869,2.147,7.869,7.045v3.544c0,2.887-1.074,4.409-3.127,5.19,2.147.7,2.845,2.22,2.845,5.149v6.67a2.505,2.505,0,0,0,.782,1.939h-5.607a2.637,2.637,0,0,1-.532-1.98v-6.389c0-2.105-.573-2.929-2.8-2.929h-2.22v11.3Zm0-15.988h2.512c2.105,0,2.929-.948,2.929-2.929v-3.293c0-1.938-.823-2.8-2.97-2.8h-2.47Z",
    transform: "translate(-428.268 -308.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M539.61,331.25v-3.96h5.524v3.877c0,1.9.657,3,2.8,3,1.939,0,2.6-1.2,2.6-2.845V329.8a3.42,3.42,0,0,0-.657-2.105,11.738,11.738,0,0,0-4.033-2.762,19.787,19.787,0,0,1-2.762-1.688,6.952,6.952,0,0,1-3.127-6.139v-1.23c0-4.575,2.512-7.337,7.827-7.337s7.7,2.6,7.7,6.92v3.21h-5.232v-2.887c0-1.939-.7-2.8-2.512-2.8-1.772,0-2.47,1.157-2.47,2.929v.823a2.7,2.7,0,0,0,.657,1.9,12.9,12.9,0,0,0,3.95,2.637c.948.49,1.855,1.073,2.8,1.688a7.065,7.065,0,0,1,3.168,6.222v2.262c0,4.7-2.679,7.493-7.994,7.493C541.715,338.952,539.61,336.273,539.61,331.25Z",
    transform: "translate(-427.509 -308.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M557.6,333.453h3.46V313.88H557.6v-4.94h11.985v4.94h-3.377v19.573h3.377v5.023H557.6Z",
    transform: "translate(-426.75 -308.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M580.039,308.94a10.869,10.869,0,0,1,4.575.907c2.637,1.157,4.284,3.669,4.284,7.869V329.7a9.436,9.436,0,0,1-1.157,5.023c-1.48,2.6-4.283,3.752-7.744,3.752H572.42V308.94Zm-2.3,24.846H579.8c2.262,0,3.585-1.355,3.585-4.575v-11.12c0-3.252-1.355-4.575-3.627-4.575h-2.022Z",
    transform: "translate(-426.124 -308.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M595.949,334.119l-.823,4.367H589.81l6.545-29.536h5.315l6.712,29.536h-5.315l-.865-4.367Zm5.357-4.659-1.939-9.849-.333-4.117-.334,4.117-1.855,9.849Z",
    transform: "translate(-425.39 -308.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M617.749,308.94a10.869,10.869,0,0,1,4.575.907c2.637,1.157,4.284,3.669,4.284,7.869V329.7a9.436,9.436,0,0,1-1.157,5.023c-1.48,2.6-4.284,3.752-7.744,3.752H610.13V308.94Zm-2.3,24.846h2.064c2.262,0,3.585-1.355,3.585-4.575v-11.12c0-3.252-1.355-4.575-3.627-4.575h-2.022Z",
    transform: "translate(-424.532 -308.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M437.442,380.646H432.21V351.11H440c5.722,0,8.2,2.23,8.2,7.452v5.023c0,4.867-2.387,7.785-8.119,7.785h-2.637Zm0-13.924h2.345c2.105,0,3.085-1.115,3.085-3.252v-4.732c0-2.262-.948-3.085-3.085-3.085h-2.345Z",
    transform: "translate(-432.043 -306.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M455.9,380.646H450.75V351.11H458.7c5.565,0,7.869,2.147,7.869,7.045V361.7c0,2.887-1.073,4.409-3.127,5.19,2.147.7,2.845,2.22,2.845,5.149v6.67a2.505,2.505,0,0,0,.782,1.939h-5.607a2.637,2.637,0,0,1-.532-1.98v-6.389c0-2.105-.573-2.929-2.8-2.929h-2.22v11.3Zm0-15.977h2.512c2.105,0,2.929-.948,2.929-2.929v-3.293c0-1.939-.823-2.8-2.97-2.8H455.9Z",
    transform: "translate(-431.261 -306.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M468.7,375.623h3.46V356.05H468.7v-4.94h11.985v4.94h-3.377v19.573h3.377v5.023H468.7Z",
    transform: "translate(-430.503 -306.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M482.33,351.11h5.44l3.5,17.634.292,4.325.292-4.325,3.418-17.634h5.4l-6.43,29.536h-5.357Z",
    transform: "translate(-429.927 -306.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M504.8,376.28l-.823,4.367H498.66l6.545-29.536h5.315l6.712,29.536h-5.315l-.865-4.367Zm5.357-4.659-1.938-9.849-.333-4.117-.334,4.117-1.855,9.849Z",
    transform: "translate(-429.238 -306.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M526.6,351.11a10.869,10.869,0,0,1,4.575.907c2.637,1.157,4.284,3.669,4.284,7.869v11.985a9.436,9.436,0,0,1-1.157,5.023c-1.48,2.6-4.284,3.752-7.744,3.752H518.98V351.11Zm-2.3,24.836h2.064c2.262,0,3.585-1.355,3.585-4.575V360.25c0-3.252-1.355-4.575-3.627-4.575H524.3Z",
    transform: "translate(-428.38 -306.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M542.509,376.28l-.823,4.367H536.37l6.545-29.536h5.315l6.712,29.536h-5.315l-.865-4.367Zm5.357-4.659-1.938-9.849-.334-4.117-.333,4.117-1.855,9.849Z",
    transform: "translate(-427.646 -306.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M439.839,393.27a10.869,10.869,0,0,1,4.575.907c2.637,1.157,4.283,3.669,4.283,7.869v11.985a9.436,9.436,0,0,1-1.157,5.023c-1.48,2.6-4.283,3.752-7.744,3.752H432.22V393.27Zm-2.314,24.846h2.064c2.262,0,3.585-1.355,3.585-4.575v-11.12c0-3.252-1.355-4.575-3.627-4.575h-2.022Z",
    transform: "translate(-432.043 -304.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M451.7,422.806V393.27h13.8v4.815h-8.525v7.337h7.494v4.867h-7.494v7.535h8.775v4.982H451.7Z",
    transform: "translate(-431.22 -304.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M468.38,393.27h5.44v24.221h7.91v5.315H468.38Z",
    transform: "translate(-430.516 -304.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M492.89,422.806V393.27h4.742l6.8,16.644,1.032,3.335-.292-3.992V393.27h4.815v29.536h-4.617L498.4,406.037l-1.032-3.544.333,4.409v15.9H492.89Z",
    transform: "translate(-429.482 -304.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M512.97,414.3v-12.4c0-6.055,3.335-8.984,8.525-8.984s8.525,2.929,8.525,8.984v12.4c0,6.18-3.335,8.984-8.525,8.984C516.18,423.28,512.97,420.518,512.97,414.3Zm11.537-.406V402.154c0-3.085-.865-4.492-3.012-4.492-2.22,0-3,1.438-3,4.492V413.89c0,3.054.782,4.45,3,4.45C523.642,418.34,524.507,416.933,524.507,413.89Z",
    transform: "translate(-428.634 -304.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M538.159,422.806H533.01V393.27h7.952c5.565,0,7.869,2.147,7.869,7.045v3.544c0,2.887-1.074,4.409-3.127,5.19,2.147.7,2.845,2.22,2.845,5.149v6.67a2.5,2.5,0,0,0,.782,1.939h-5.607a2.637,2.637,0,0,1-.531-1.98v-6.389c0-2.105-.573-2.929-2.8-2.929h-2.22v11.3Zm0-15.977h2.512c2.105,0,2.929-.948,2.929-2.929v-3.293c0-1.939-.823-2.8-2.97-2.8h-2.47Z",
    transform: "translate(-427.788 -304.963)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M560.492,422.807h-5.315v-24.68H550.32V393.26H565.4v4.867h-4.9v24.68Z",
    transform: "translate(-427.057 -304.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31",
    "data-name": "Trazado 31",
    d: "M567.76,422.806V393.27h13.8v4.815h-8.525v7.337h7.494v4.867h-7.494v7.535h8.775v4.982H567.76Z",
    transform: "translate(-426.321 -304.963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextoNegro);
export default __webpack_public_path__ + "static/media/LogoTextoNegro.6bb34e6e97ba59c4f71fb8c24e3d2df9.svg";
export { ForwardRef as ReactComponent };